import React from "react";
import {useMst} from "../../mobx";
import {observer} from "mobx-react-lite";

type Scopes = "users.users.own.read" |
"users.users.own.update" |
"users.users.own.delete" |
"users.users.any.create" |
"users.users.any.read" |
"users.users.any.update" |
"users.users.any.delete" |
"users.users_profiles_roles_permissions.any.create" |
"users.users_profiles_roles_permissions.any.read" |
"users.users_profiles_roles_permissions.any.delete" |
"questions.skills.any.create" |
"questions.skills.any.read" |
"questions.skills.any.update" |
"questions.skills.any.delete" |
"questions.topics.any.create" |
"questions.topics.any.read" |
"questions.topics.any.update" |
"questions.topics.any.delete" |
"questions.questions.any.create" |
"questions.questions.any.read" |
"questions.questions.any.update" |
"questions.questions.any.delete"

interface FeatureAppearanceProps {
  feature: Scopes[];
  children: (featureExist: boolean) => React.ReactNode;
}

export default observer(({ children, feature }: FeatureAppearanceProps) => {
  const { authStore } = useMst();
  const { permissionsList } = authStore;

  return <>{children(feature.every(feature => permissionsList.includes(feature)))}</>;
});